import { FormattedMessage } from "react-intl";
import { useSearchParams } from "react-router-dom";
import { handleSearchParamsChange } from "../../helpers/functions";

const BootyPagination = ({
  metaData,
  currentPage,
  setCurrentPage,
  limit,
  setLimit,
}) => {
  const [searchParams] = useSearchParams();

  let { totalResults } = metaData || {};

  const onChangePage = (clickedPage, newLimit) => {
    const search = Object.fromEntries([...searchParams]);

    const params = {};
    if (clickedPage) params["page"] = clickedPage;
    if (newLimit) params["limit"] = newLimit;

    const newSearch = handleSearchParamsChange(search, params);

    // Update state from the props
    if (clickedPage) setCurrentPage(clickedPage);
    if (newLimit) setLimit(newLimit);
  };

  const handleBackButtonClick = () => {
    if (currentPage > 1) {
      onChangePage(currentPage - 1);
    }
  };

  const handleNextButtonClick = () => {
    const pages = getNumberOfPages(totalResults, limit);
    if (currentPage < pages) {
      onChangePage(currentPage + 1);
    }
  };

  const handlePageNumber = (e) => {
    onChangePage(Number(e.target.value));
  };

  const pages = getNumberOfPages(totalResults, limit);
  const pageItems = toPages(pages);
  const nextDisabled = currentPage === pageItems.length;
  const previosDisabled = currentPage === 1;

  function getNumberOfPages(totalResults, limit) {
    const numberOfPages = Math.ceil(Number(totalResults) / limit);
    return numberOfPages;
  }

  function toPages(pages) {
    const results = [];

    for (let i = 0; i < pages; i++) {
      results.push(i + 1);
    }

    return results;
  }

  const getSelectedLimit = () => {
    const url = new URLSearchParams(searchParams);
    const selectedLimit = url.get("limit");
    return selectedLimit || limit;
  };

  return (
    <div className="d-flex justify-content-end align-items-center gap-2">
      <nav className="table-pager">
        <ul className="pagination">
          <li className="page-item">
            <button
              className="page-link prev-link"
              onClick={handleBackButtonClick}
              disabled={previosDisabled}
              aria-disabled={previosDisabled}
              aria-label="previous page"
            >
              <FormattedMessage id={"previous"} />
            </button>
          </li>
          {pageItems.map((pageItem) => {
            const className =
              pageItem === currentPage ? "page-item active" : "page-item";

            return (
              <li key={pageItem} className={className}>
                <button
                  className="page-link"
                  onClick={handlePageNumber}
                  value={pageItem}
                >
                  {pageItem}
                </button>
              </li>
            );
          })}
          <li className="page-item">
            <button
              className="page-link nxt-link"
              onClick={handleNextButtonClick}
              disabled={nextDisabled}
              aria-disabled={nextDisabled}
              aria-label="next page"
            >
              <FormattedMessage id={"next"} />
            </button>
          </li>
        </ul>
      </nav>
      <div className="table-select">
        <select
          onChange={(e) => onChangePage(currentPage, e.target.value)} // Pass the current page and new limit
          value={getSelectedLimit()}
        >
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={15}>15</option>
          <option value={20}>20</option>
          <option value={25}>25</option>
        </select>
      </div>
    </div>
  );
};

export default BootyPagination;
